import { Swiper, NoticeBar, Mask } from 'antd-mobile';
import notice from '@/assets/images/poster/xiaoxi.svg';
import banner1 from '@/assets/images/poster/banner1.png';
import banner2 from '@/assets/images/poster/banner2.png';
import close_bai from '@/assets/images/close.png';
import './swiper.less';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import classNames from 'classnames';
import { useJumpLink } from '@/utils/hooks';

const BannerMask = ({ allBannerList }) => {
  const [visible, setVisible] = useState(false);
  const [handlJumpLink] = useJumpLink();

  const alertBannerList = allBannerList?.alertBannerList;
  const [alertList, setAlertList] = useState(alertBannerList);

  useEffect(() => {
    // 初次加载时显示全部 alertBannerList
    if (
      alertBannerList.length > 0 &&
      !sessionStorage.getItem('lastDisplayedTime')
    ) {
      checkAndUpdateAlerts();
      setVisible(true);
    } else {
      checkAndUpdateAlerts();
    }
  }, [alertBannerList.length]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      checkAndUpdateAlerts();
    }, 60 * 60 * 1000); // 每1小时检查一次

    return () => clearInterval(intervalId); // 清除定时器
  }, []);

  const checkAndUpdateAlerts = () => {
    const currentTime = dayjs();

    const updatedTimes = {
      ...JSON.parse(sessionStorage.getItem('lastDisplayedTime') || '{}')
    };

    const filteredAlerts = alertBannerList.filter(alert => {
      const { id, interval } = alert;
      const lastTime = updatedTimes[id];
      const diff = currentTime.diff(lastTime, 'minutes');
      // 如果没有记录上次显示时间，或已经到达显示间隔
      if (!lastTime || diff >= interval * 60) {
        updatedTimes[id] = currentTime;
        return true;
      }
      return false;
    });

    // 更新显示列表为符合间隔的 alerts
    if (filteredAlerts.length > 0) {
      setAlertList(filteredAlerts);
      setVisible(true);
      // 更新 sessionStorage
      sessionStorage.setItem('lastDisplayedTime', JSON.stringify(updatedTimes));
    }
  };

  return (
    <>
      <Mask visible={visible} className="banner-mask-content">
        <div>
          {alertList.length > 0 ? (
            <Swiper
              loop
              autoplay
              autoplayInterval={5000}
              style={{
                '--track-padding': ' 0 0 28px'
              }}
              // indicator={alertList.length === 1 && undefined}
              indicatorProps={{
                color: 'white',
                // style: { height: '8px' },
                className: classNames({ hidden: alertList.length === 1 })
              }}
            >
              {alertList.map((item, index) => (
                <Swiper.Item key={item.id}>
                  <div className="flex items-center justify-center ">
                    <img
                      src={item.url}
                      onClick={() => handlJumpLink(item)}
                      alt={item.remark || ''}
                      className="rounded-2xl w-[333px]"
                    />
                  </div>
                </Swiper.Item>
              ))}
            </Swiper>
          ) : null}
          <div className="flex items-center justify-center mt-4">
            <div
              onClick={() => setVisible(false)}
              className="flex items-center justify-center"
            >
              <img className="w-9 h-9" src={close_bai} alt="" />
            </div>
          </div>
        </div>
      </Mask>
    </>
  );
};
export default BannerMask;
